@if (errorText) {
  <div class="shared-error-messag">
    <small class="p-error">{{errorText}}</small>
  </div>
}
